<template>
    <Modal id="requeueModal"  class="modal-container " data-bs-backdrop="static">
        <template #header>
            <h5 style="color: #212529;">Reencolar</h5>
        </template>
        <template #body>
            <div class="row">
                <p>
                    ¿Está seguro de reencolar los elementos filtrados?
                </p>
            </div>
        </template>
        <template #footer>
            <button ref="closeButton" type="button" class="btn btn-outline-primary d-none" data-bs-dismiss="modal" />
            <button ref="cancelButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal"
                @click="cancelRequest">
                Cancelar
            </button>
            <button type="button" class="btn bg-gradient-success" @click="confirm">
                Aceptar
            </button>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/components/ModalHotakauth.vue';
export default {
    name: "ReQueue",
    components: {
        Modal
    },
    emits: ['confirm-requeue'],
    methods: {
        hideModal() {
            let button = this.$refs.closeButton;
            if (button) button.click()
        },
        confirm() {
            this.$emit('confirm-requeue')
            this.hideModal();
        },
    },

};
</script>
<style>
.modal-container {
min-height: 200px !important;
}
</style>

